import './footer.scss'
import { Link } from 'react-router-dom';
import Tooltip from '../../content/tooltip/Tooltip';
import { img_logo_logLetterWhite_app } from '../../../core/hooks/assetsConstants';
import { scrollToTop } from '../../content/ScrollToTop';

export default function Footer() {

    // Descargar guia de la pagina
    const handdleDownload = () => {
        console.log('click')
    }

    return (
        <section className='content_footer'>

            <div className='footer'>
                <div className='header'>
                    <div className='logo'>
                        <img src={img_logo_logLetterWhite_app} width="200px" alt="Logo" />
                    </div>

                    <div className='button_top' onClick={() => scrollToTop('smooth')}>
                        <i className="fa-solid fa-chevrons-up"></i>
                    </div>
                </div>

                <div className='items'>
                    <div className='resources'>
                        <h4 className='subtitle'>Resources</h4>
                        <div className='content_links'>
                            <div className='links'>
                                <Link to="/acerca-de" className=""> <span>Acerca del diccionario</span></Link>
                            </div>

                            <div className='links'>
                                <span className='link' onClick={handdleDownload}>Guía de illustraciones</span>
                            </div>

                            <div className='links'>
                                <Link to="categorias" className=""> <span>Categorías</span></Link>
                            </div>

                            <div className='links'>
                                <Link to="/contacto" className=""> <span>Contacto</span></Link>
                            </div>

                            <div className='links'>
                                <a href="https://admin.sign-tech.org" target='_blank'> <span>Administración</span></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr className='divisor' />

            <div className='copyright'>

                <div className='policy'>

                    <div className='information'>
                        © 2024 SeñaTech, All rights reserved.
                    </div>

                    <div className='redes'>
                        <Tooltip text='Facebook' position='top'>
                            <a href="https://www.facebook.com/profile.php?id=61572048838644" target='_blank'><i className="fa-brands fa-facebook-f"></i></a>
                        </Tooltip>
                        <Tooltip text='TikTok' position='top'>
                            <a href="https://www.tiktok.com/@senatech_oficial?is_from_webapp=1&sender_device=pc" target='_blank'><i className="fa-brands fa-tiktok"></i></a>
                        </Tooltip>
                        <Tooltip text='Youtube' position='top'>
                            <a href="https://www.youtube.com/@Se%C3%B1aTech_Oficial" target='_blank'><i className="fa-brands fa-youtube"></i></a>
                        </Tooltip>
                    </div>
                </div>
            </div>

        </section>
    )
}
